<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>FORMULAIRE DE CREATION D'ENTREPRISE</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>FORMULAIRE DE CREATION D'ENTREPRISE</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="form-progress-section pt-5 pb-5 bg-light">
    <div class="container">
        <div class="progress-container">
            <div class="progress-steps">
                <div class="step-item" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">
                    <div class="step-number">1</div>
                    <div class="step-label">Informations Personnelles</div>
                </div>
                <div class="step-item" [class.active]="currentStep >= 2" [class.completed]="currentStep > 2">
                    <div class="step-number">2</div>
                    <div class="step-label">Informations Entreprise</div>
                </div>
                <div class="step-item" [class.active]="currentStep >= 3" [class.completed]="currentStep > 3">
                    <div class="step-number">3</div>
                    <div class="step-label">Validation</div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="post-job-area pt-100">
    <div class="container">
        <form enctype="multipart/form-data" [formGroup]="form" (ngSubmit)="onSubmit()">
            
            <!-- Step 1: Personal Information -->
            <div class="form-step" [class.active]="currentStep === 1">
                <div class="shadow mb-5 enhanced-form-card">
                    <div class="card-header">
                        <div class="header-content">
                            <i class="icofont-user header-icon"></i>
                            <h3 class="card-title">INFORMATIONS DU DEMANDEUR</h3>
                            <p class="card-subtitle">Renseignez vos informations personnelles</p>
                        </div>
                        <div class="step-indicator">
                            <span class="step-text">Étape 1 sur 3</span>
                        </div>
                    </div>
                    
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-user input-icon"></i>
                                        PRÉNOM
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="first_name" type="text" class="form-control" 
                                           placeholder="Votre prénom" />
                                    <div class="input-feedback" *ngIf="form.get('first_name').touched && form.get('first_name').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-user input-icon"></i>
                                        NOM 
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="last_name" type="text" class="form-control" 
                                           placeholder="Votre nom" />
                                    <div class="input-feedback" *ngIf="form.get('last_name').touched && form.get('last_name').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-gender input-icon"></i>
                                        SEXE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="gender-selection">
                                        <div class="gender-option" [class.selected]="form.get('gender').value === 'M'">
                                            <input class="form-check-input" type="radio" name="gender" formControlName="gender"
                                                   id="male" value="M" />
                                            <label class="gender-label" for="male">
                                                <div class="row">
                                                    <div class="col-lg-6 text-start">
                                                        <i class="icofont-male gender-icon"></i>
                                                    </div>
                                                    <div class="col-lg-6 text-center pt-1">
                                                        <span>HOMME</span>
                                                    </div>
                                                </div>  
                                            </label>
                                        </div>
                                        <div class="gender-option" [class.selected]="form.get('gender').value === 'F'">
                                            <input class="form-check-input" type="radio" name="gender" formControlName="gender"
                                                   id="female" value="F" />
                                            <label class="gender-label" for="female">
                                                <div class="row">
                                                    <div class="col-lg-6 text-start">
                                                        <i class="icofont-female gender-icon"></i>
                                                    </div>
                                                    <div class="col-lg-6 text-center pt-1">
                                                        <span>FEMME</span>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-calendar input-icon"></i>
                                        DATE DE NAISSANCE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="date_of_birth" type="date" class="form-control" />
                                    <div class="input-feedback" *ngIf="form.get('date_of_birth').touched && form.get('date_of_birth').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-flag input-icon"></i>
                                        NATIONALITÉ
                                        <span class="text-danger">*</span>
                                    </label>
                                    <select formControlName="nationality" class="form-select">
                                        <option value="">Sélectionnez votre nationalité</option>
                                        <option *ngFor="let country of countryService.value" [value]="country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <div class="input-feedback" *ngIf="form.get('nationality').touched && form.get('nationality').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-email input-icon"></i>
                                        EMAIL 
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="email" type="email" class="form-control" 
                                           placeholder="votre.email@exemple.com" />
                                    <div class="input-feedback" *ngIf="form.get('email').touched && form.get('email').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-profession input-icon"></i>
                                        FONCTION
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="profession" type="text" class="form-control" 
                                           placeholder="Votre fonction dans l'entreprise" />
                                    <div class="input-feedback" *ngIf="form.get('profession').touched && form.get('profession').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-phone input-icon"></i>
                                        TÉLÉPHONE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="phone_number" placeholder="622 00 00 00" mask="000 00 00 00" 
                                           type="text" class="form-control" />
                                    <div class="input-feedback" *ngIf="form.get('phone_number').touched && form.get('phone_number').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-location input-icon"></i>
                                        ADRESSE
                                    </label>
                                    <input formControlName="address" type="text" class="form-control" 
                                           placeholder="Votre adresse personnelle" />
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-lock input-icon"></i>
                                        MOT DE PASSE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="password-input-wrapper">
                                        <input type="password" class="form-control" 
                                               formControlName="password" placeholder="Votre mot de passe" 
                                               autocomplete="new-password" />
                                        <button type="button" class="password-toggle" (click)="togglePasswordVisibility('password')">
                                            <i class="icofont-eye" *ngIf="!passwordVisible"></i>
                                            <i class="icofont-eye-blocked" *ngIf="passwordVisible"></i>
                                        </button>
                                    </div>
                                    <div class="password-strength" *ngIf="form.get('password').value">
                                        <div class="strength-bar">
                                            <div class="strength-fill" [class]="getPasswordStrengthClass()"></div>
                                        </div>
                                        <span class="strength-text">{{ getPasswordStrengthText() }}</span>
                                    </div>
                                    <div class="input-feedback" *ngIf="form.get('password').touched && form.get('password').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-lock input-icon"></i>
                                        CONFIRMER LE MOT DE PASSE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="password-input-wrapper">
                                        <input type="password" class="form-control" 
                                               formControlName="password1" placeholder="Confirmez votre mot de passe" 
                                               autocomplete="new-password" />
                                        <button type="button" class="password-toggle" (click)="togglePasswordVisibility('password1')">
                                            <i class="icofont-eye" *ngIf="!password1Visible"></i>
                                            <i class="icofont-eye-blocked" *ngIf="password1Visible"></i>
                                        </button>
                                    </div>
                                    <div class="input-feedback" *ngIf="form.get('password1').touched && form.get('password1').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                    <div class="input-feedback error" *ngIf="form.hasError('notSame')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Les mots de passe ne correspondent pas</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="password-requirements">
                                    <h6 class="requirements-title">
                                        <i class="icofont-info requirements-icon"></i>
                                        Exigences du mot de passe
                                    </h6>
                                    <div class="requirements-list">
                                        <div class="requirement-item" [class.valid]="hasUppercase()">
                                            <i class="icofont-check requirement-icon"></i>
                                            <span>Au moins une lettre majuscule</span>
                                        </div>
                                        <div class="requirement-item" [class.valid]="hasNumber()">
                                            <i class="icofont-check requirement-icon"></i>
                                            <span>Au moins un chiffre</span>
                                        </div>
                                        <div class="requirement-item" [class.valid]="hasSpecialChar()">
                                            <i class="icofont-check requirement-icon"></i>
                                            <span>Au moins un caractère spécial</span>
                                        </div>
                                        <div class="requirement-item" [class.valid]="hasMinLength()">
                                            <i class="icofont-check requirement-icon"></i>
                                            <span>Au moins 8 caractères</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="card-footer">
                        <button type="button" class="btn btn-next" (click)="nextStep()" [disabled]="!isStep1Valid()">
                            <span>Suivant</span>
                            <i class="icofont-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Step 2: Company Information -->
            <div class="form-step" [class.active]="currentStep === 2">
                <div class="shadow mb-5 enhanced-form-card">
                    <div class="card-header">
                        <div class="header-content">
                            <i class="icofont-enterprise header-icon"></i>
                            <h3 class="card-title">INFORMATIONS DE L'ENTREPRISE</h3>
                            <p class="card-subtitle">Renseignez les informations de votre entreprise</p>
                        </div>
                        <div class="step-indicator">
                            <span class="step-text">Étape 2 sur 3</span>
                        </div>
                    </div>
                    
                    <div class="card-body" formGroupName="supplier">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-enterprise input-icon"></i>
                                        NOM DE L'ENTREPRISE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control" 
                                           formControlName="name" placeholder="Nom de votre entreprise" />
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('name').touched && form.get('supplier').get('name').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-document input-icon"></i>
                                        N° RCCM
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control" 
                                           formControlName="rccm" placeholder="Numéro RCCM" />
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('rccm').touched && form.get('supplier').get('rccm').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-calendar input-icon"></i>
                                        DATE DE CRÉATION
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input formControlName="year_of_registration" type="date" class="form-control" />
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('year_of_registration').touched && form.get('supplier').get('year_of_registration').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-legal input-icon"></i>
                                        FORME JURIDIQUE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="legal-form-selection">
                                        <div class="legal-form-option" *ngFor="let companyType of companyTypeService.value">
                                            <input class="form-check-input" type="radio" formControlName="type"
                                                   name="type" [id]="'type-' + companyType.id" [value]="companyType.id" />
                                            <label class="legal-form-label" [for]="'type-' + companyType.id">
                                                <i class="icofont-enterprise legal-form-icon"></i>
                                                <span>{{ companyType.name }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('type').touched && form.get('supplier').get('type').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>DESCRIPTION
                                    <span class="text-danger">*</span></label>
                                <div class="NgxEditor__Wrapper">
                                    <ngx-editor-menu [editor]="editor">
                                    </ngx-editor-menu>
                                    <ngx-editor formControlName="description" cols="30" [editor]="editor"
                                        [ngModel]="html" [placeholder]="'Saisissez ici...'"></ngx-editor>
                                </div>
                                <small class="text-bg-danger" *ngIf="
                                        form.get('supplier').get('description')
                                            .touched &&
                                        form
                                            .get('supplier')
                                            .get('description')
                                            .hasError('required')
                                    ">Champs obligatoire.</small>
                            </div>
                        </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <div class="categories-section">
                                        <div class="categories-header">
                                            <label class="form-label">
                                                <i class="icofont-categories input-icon"></i>
                                                DOMAINES D'ACTIVITÉ
                                                <span class="text-danger">*</span>
                                            </label>
                                            <p class="categories-subtitle">Sélectionnez au maximum 5 domaines d'activité</p>
                                        </div>
                                        
                                        <div class="categories-filter">
                                            <input type="text" class="form-control" 
                                                   [(ngModel)]="search" placeholder="Filtrer les catégories..." 
                                                   formControlName="search" autocomplete="on">
                                        </div>

                                        <div class="categories-grid">
                                            <div class="category-item" *ngFor="let category of filteredCategories; let i = index">
                                                <input type="checkbox" [value]="category.id" class="category-checkbox"
                                                       (change)="onCheckboxChange($event)" [id]="'category-' + category.id" />
                                                <label class="category-label" [for]="'category-' + category.id">
                                                    <!-- <i class="icofont-category category-icon"></i> -->
                                                    <span>{{ category.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                        
                                        <div class="selected-categories">
                                            <span class="selected-count">{{ getSelectedCategoriesCount() }} / 5 sélectionnés</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-website input-icon"></i>
                                        SITE INTERNET
                                    </label>
                                    <input type="url" formControlName="website" class="form-control" 
                                           placeholder="https://www.votreentreprise.com" />
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-phone input-icon"></i>
                                        TÉLÉPHONE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="tel" mask="000 00 00 00" class="form-control"
                                           formControlName="phone_number" placeholder="622 00 00 00" />
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('phone_number').touched && form.get('supplier').get('phone_number').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-email input-icon"></i>
                                        EMAIL DE L'ENTREPRISE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="email" formControlName="email" class="form-control" 
                                           placeholder="contact@votreentreprise.com" />
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('email').touched && form.get('supplier').get('email').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-region input-icon"></i>
                                        RÉGION
                                        <span class="text-danger">*</span>
                                    </label>
                                    <select formControlName="region" class="form-select"
                                            (change)="onRegionsChanged($event)">
                                        <option value="null">Sélectionnez une région</option>
                                        <option *ngFor="let region of regionService.value" [value]="region.id">
                                            {{ region.name }}
                                        </option>
                                    </select>
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('region').touched && form.get('supplier').get('region').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-prefecture input-icon"></i>
                                        PRÉFECTURE
                                    </label>
                                    <select class="form-select" formControlName="prefecture"
                                            (change)="onPrefecturesChanged($event)">
                                        <option value="null">Sélectionnez une préfecture</option>
                                        <option *ngFor="let prefecture of prefectures" [value]="prefecture.id">
                                            {{ prefecture.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-4">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-commune input-icon"></i>
                                        COMMUNE
                                    </label>
                                    <select formControlName="commune" class="form-select">
                                        <option value="null">Sélectionnez une commune</option>
                                        <option *ngFor="let commune of communes" [value]="commune.id">
                                            {{ commune.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-location input-icon"></i>
                                        ADRESSE PRINCIPALE
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control" 
                                           formControlName="address" placeholder="Adresse complète de l'entreprise" />
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('address').touched && form.get('supplier').get('address').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Ce champ est obligatoire</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <div class="terms-checkbox">
                                        <input type="checkbox" value="true" class="form-check-input terms-input"
                                               formControlName="terms_and_conditions" id="terms-checkbox" />
                                        <label class="terms-label" for="terms-checkbox">
                                            <i class="icofont-check terms-icon"></i>
                                            <span>
                                                J'accepte les 
                                                <a class="text-default" target="_blank" routerLink="/terms-and-conditions">Termes et Conditions</a>
                                                et la 
                                                <a class="text-default" target="_blank" routerLink="/privacy-policy">Politique de Confidentialité</a>
                                            </span>
                                        </label>
                                    </div>
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('terms_and_conditions').touched && form.get('supplier').get('terms_and_conditions').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Vous devez accepter les termes et conditions</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group enhanced-input">
                                    <label class="form-label">
                                        <i class="icofont-security input-icon"></i>
                                        VÉRIFICATION
                                        <span class="text-danger">*</span>
                                    </label>
                                    <div class="recaptcha-wrapper">
                                        <re-captcha class="w-100" id="recaptcha" formControlName="recaptcha"></re-captcha>
                                    </div>
                                    <div class="input-feedback" *ngIf="form.get('supplier').get('recaptcha').touched && form.get('supplier').get('recaptcha').hasError('required')">
                                        <i class="icofont-warning feedback-icon"></i>
                                        <span>Veuillez compléter la vérification</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="card-footer">
                        <button type="button" class="btn btn-prev" (click)="prevStep()">
                            <i class="icofont-arrow-left"></i>
                            <span>Précédent</span>
                        </button>
                        <button type="button" class="btn btn-next" (click)="nextStep()" [disabled]="!isStep2Valid()">
                            <span>Suivant</span>
                            <i class="icofont-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Step 3: Validation -->
            <div class="form-step" [class.active]="currentStep === 3">
                <div class="shadow mb-5 enhanced-form-card">
                    <div class="card-header">
                        <div class="header-content">
                            <i class="icofont-validation header-icon"></i>
                            <h3 class="card-title">VALIDATION FINALE</h3>
                            <p class="card-subtitle">Vérifiez vos informations avant de créer votre compte</p>
                        </div>
                        <div class="step-indicator">
                            <span class="step-text">Étape 3 sur 3</span>
                        </div>
                    </div>
                    
                    <div class="card-body">
                        <div class="validation-summary">
                            <div class="summary-section">
                                <h5 class="summary-title">
                                    <i class="icofont-user summary-icon"></i>
                                    Informations Personnelles
                                </h5>
                                <div class="summary-content">
                                    <div class="summary-item">
                                        <span class="item-label">Nom complet:</span>
                                        <span class="item-value">{{ form.get('first_name').value }} {{ form.get('last_name').value }}</span>
                                    </div>
                                    <div class="summary-item">
                                        <span class="item-label">Email:</span>
                                        <span class="item-value">{{ form.get('email').value }}</span>
                                    </div>
                                    <div class="summary-item">
                                        <span class="item-label">Téléphone:</span>
                                        <span class="item-value">{{ form.get('phone_number').value }}</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="summary-section">
                                <h5 class="summary-title">
                                    <i class="icofont-building summary-icon"></i>
                                    Informations Entreprise
                                </h5>
                                <div class="summary-content">
                                    <div class="summary-item">
                                        <span class="item-label">Nom de l'entreprise:</span>
                                        <span class="item-value">{{ form.get('supplier').get('name').value }}</span>
                                    </div>
                                    <div class="summary-item">
                                        <span class="item-label">RCCM:</span>
                                        <span class="item-value">{{ form.get('supplier').get('rccm').value }}</span>
                                    </div>
                                    <div class="summary-item">
                                        <span class="item-label">Adresse:</span>
                                        <span class="item-value">{{ form.get('supplier').get('address').value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="final-actions">
                            <button type="button" class="btn btn-prev" (click)="prevStep()">
                                <i class="icofont-arrow-left"></i>
                                <span>Modifier</span>
                            </button>
                            <button type="submit" class="btn btn-submit" [disabled]="loading">
                                <i class="icofont-check submit-icon" *ngIf="!loading"></i>
                                <i class="icofont-spinner-alt-1 icofont-spin" *ngIf="loading"></i>
                                <span>{{ loading ? 'Création en cours...' : 'Créer mon compte' }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

 <div class="">
   <div class="row">
     <div class="col-lg-12">
       <div class="creation-steps-section">
         <div class="section-header text-center">
           <h2 class="section-title">Comment créer votre compte BSTP</h2>
           <p class="section-subtitle">Suivez ces étapes simples pour rejoindre notre plateforme</p>
         </div>
         
         <div class="steps-container container">
           <div class="row">
             <!-- Étape 1 -->
             <div class="col-lg-4 col-md-6 mb-4">
               <div class="step-card">
                 <div class="step-number">
                   <span>1</span>
                 </div>
                 <div class="step-content">
                   <div class="step-icon">
                     <i class="icofont-user"></i>
                   </div>
                   <h4 class="step-title">Informations Personnelles</h4>
                   <p class="step-description">
                     Remplissez vos informations personnelles : nom, prénom, email et numéro de téléphone. 
                     Ces informations sont essentielles pour votre identification.
                   </p>
                   <ul class="step-details">
                     <li><i class="icofont-check-circled"></i> Nom et prénom</li>
                     <li><i class="icofont-check-circled"></i> Adresse email valide</li>
                     <li><i class="icofont-check-circled"></i> Numéro de téléphone</li>
                     <li><i class="icofont-check-circled"></i> Mot de passe sécurisé</li>
                   </ul>
                 </div>
               </div>
             </div>
             
             <!-- Étape 2 -->
             <div class="col-lg-4 col-md-6 mb-4">
               <div class="step-card">
                 <div class="step-number">
                   <span>2</span>
                 </div>
                 <div class="step-content">
                   <div class="step-icon">
                     <i class="icofont-building"></i>
                   </div>
                   <h4 class="step-title">Informations Entreprise</h4>
                   <p class="step-description">
                     Ajoutez les détails de votre entreprise : nom, RCCM, adresse et autres informations 
                     légales nécessaires pour la validation.
                   </p>
                   <ul class="step-details">
                     <li><i class="icofont-check-circled"></i> Nom de l'entreprise</li>
                     <li><i class="icofont-check-circled"></i> Numéro RCCM</li>
                     <li><i class="icofont-check-circled"></i> Adresse complète</li>
                     <li><i class="icofont-check-circled"></i> Documents légaux</li>
                   </ul>
                 </div>
               </div>
             </div>
             
             <!-- Étape 3 -->
             <div class="col-lg-4 col-md-6 mb-4">
               <div class="step-card">
                 <div class="step-number">
                   <span>3</span>
                 </div>
                 <div class="step-content">
                   <div class="step-icon">
                     <i class="icofont-check-circled"></i>
                   </div>
                   <h4 class="step-title">Validation & Activation</h4>
                   <p class="step-description">
                     Vérifiez toutes vos informations et soumettez votre demande. 
                     Notre équipe validera votre compte sous 24-48h.
                   </p>
                   <ul class="step-details">
                     <li><i class="icofont-check-circled"></i> Vérification des données</li>
                     <li><i class="icofont-check-circled"></i> Soumission du formulaire</li>
                     <li><i class="icofont-check-circled"></i> Validation par notre équipe</li>
                     <li><i class="icofont-check-circled"></i> Activation du compte</li>
                   </ul>
                 </div>
               </div>
             </div>
           </div>
         </div>
         
         <!-- Avantages -->
         <div class="benefits-section mt-5 container">
           <div class="row">
             <div class="col-lg-12">
               <div class="benefits-header text-center mb-4">
                 <h3 class="benefits-title">Pourquoi rejoindre BSTP ?</h3>
                 <p class="benefits-subtitle">Découvrez les avantages de notre plateforme</p>
               </div>
             </div>
           </div>
           
           <div class="row">
             <div class="col-lg-3 col-md-6 mb-4">
               <div class="benefit-card">
                 <div class="benefit-icon">
                    <i class="icofont-handshake-deal"></i>
                 </div>
                 <h5 class="benefit-title">Réseau Professionnel</h5>
                 <p class="benefit-description">
                   Connectez-vous avec des professionnels du secteur et développez votre réseau.
                 </p>
               </div>
             </div>
             
             <div class="col-lg-3 col-md-6 mb-4">
               <div class="benefit-card">
                 <div class="benefit-icon">
                    <i class="icofont-brand-target"></i>
                 </div>
                 <h5 class="benefit-title">Opportunités Commerciales</h5>
                 <p class="benefit-description">
                   Accédez à des appels d'offres et des opportunités commerciales exclusives.
                 </p>
               </div>
             </div>
             
             <div class="col-lg-3 col-md-6 mb-4">
               <div class="benefit-card">
                 <div class="benefit-icon">
                   <i class="icofont-certificate"></i>
                 </div>
                 <h5 class="benefit-title">Certification & Formation</h5>
                 <p class="benefit-description">
                   Bénéficiez de formations et certifications pour développer vos compétences.
                 </p>
               </div>
             </div>
             
             <div class="col-lg-3 col-md-6 mb-4">
               <div class="benefit-card">
                 <div class="benefit-icon">
                   <i class="icofont-support"></i>
                 </div>
                 <h5 class="benefit-title">Support Technique</h5>
                 <p class="benefit-description">
                   Profitez d'un support technique dédié pour toutes vos questions.
                 </p>
               </div>
             </div>
           </div>
         </div>
         
         <!-- FAQ -->
         <div class="faq-section mt-5 container">
           <div class="row">
             <div class="col-lg-12">
               <div class="faq-header text-center mb-4">
                 <h3 class="faq-title">Questions Fréquentes</h3>
                 <p class="faq-subtitle">Trouvez rapidement les réponses à vos questions</p>
               </div>
             </div>
           </div>
           
           <div class="row">
             <div class="col-lg-12 mx-auto">
               <div class="accordion" id="faqAccordion">
                 <div class="accordion-item">
                   <h2 class="accordion-header" id="faq1">
                     <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                       Combien de temps faut-il pour valider mon compte ?
                     </button>
                   </h2>
                   <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="faq1" data-bs-parent="#faqAccordion">
                     <div class="accordion-body">
                       La validation de votre compte prend généralement 24 à 48 heures. Notre équipe vérifie toutes les informations fournies pour assurer la qualité de notre réseau.
                     </div>
                   </div>
                 </div>
                 
                 <div class="accordion-item">
                   <h2 class="accordion-header" id="faq2">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                       Quels documents sont nécessaires ?
                     </button>
                   </h2>
                   <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="faq2" data-bs-parent="#faqAccordion">
                     <div class="accordion-body">
                       Vous aurez besoin de votre RCCM, des documents d'identité et des informations de contact valides. Tous les documents doivent être à jour et conformes aux exigences légales.
                     </div>
                   </div>
                 </div>
                 
                 <div class="accordion-item">
                   <h2 class="accordion-header" id="faq3">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                       La création de compte est-elle gratuite ?
                     </button>
                   </h2>
                   <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="faq3" data-bs-parent="#faqAccordion">
                     <div class="accordion-body">
                       Oui, la création de compte est entièrement gratuite. Cependant, certains services premium peuvent nécessiter un abonnement.
                     </div>
                   </div>
                 </div>
                 
                 <div class="accordion-item">
                   <h2 class="accordion-header" id="faq4">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                       Puis-je modifier mes informations après création ?
                     </button>
                   </h2>
                   <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="faq4" data-bs-parent="#faqAccordion">
                     <div class="accordion-body">
                       Oui, vous pouvez modifier la plupart de vos informations depuis votre tableau de bord une fois votre compte activé.
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
         
         <!-- Contact -->
         <!-- <div class="contact-section mt-5 text-center">
           <div class="contact-content">
             <h4 class="contact-title text-white">Besoin d'aide ?</h4>
             <p class="contact-description">
               Notre équipe est là pour vous accompagner dans votre processus de création de compte
             </p>
             <div class="contact-actions">
               <a routerLink="/contact" class="btn btn-primary me-3">
                 <i class="icofont-envelope"></i>
                 Nous contacter
               </a>
               <a routerLink="/faq" class="btn btn-outline-primary">
                 <i class="icofont-question-circle"></i>
                 FAQ
               </a>
             </div>
           </div>
         </div> -->
       </div>
     </div>
   </div>
 </div>